import type { WebModule } from "../../core/modules";
import { UrablePage } from "./page";

const urable: WebModule = {
  name: "x-urable",
  routes: [{ path: "/donnees-urable", element: <UrablePage />, adminOnly: true }],
  nav: [
    {
      title: "Données",
      order: 80,
      adminOnly: true,
      items: [{ to: "/donnees-urable", label: "Données Urable", icon: "file", adminOnly: true }],
    },
  ],
};
export default urable;
